import React from "react";
import { X } from "react-feather";
import theme from "../../Styles/theme";
import { DivX } from "./styles";

interface Props{
    execute():void;
}
export function ModalDivX({execute}:Props){
return(
    <DivX>
    <X
      onClick={()=>{
        execute()
        console.log("executei")
      }}
      style={{ cursor: "pointer" }}
      color={theme.colors.attention}
      size={"28px"}
    />
  </DivX>
)
   

}